import { ApiFragment } from '../../core/records/entities/api-fragment.class';
import { Face } from '../entities/face.entity';
import { FACES_FIELD_DEFINITION_DOTTED_KEY } from '../constants/field-definition-keys.constants';

const [family, property] = FACES_FIELD_DEFINITION_DOTTED_KEY.split('.');

export function GetRecordFaces(record: ApiFragment): Face[] {
    return record.get(family, property)?.Face ?? [];
}

export function SetRecordFaces(record: ApiFragment, facesRecord: ApiFragment): ApiFragment {
    const faces = facesRecord.get(family, property);
    record.set(family, property, faces);

    return record;
}
